import { plainToClass } from "class-transformer";
import { JobFunctionEntity, ContactListingFormObject } from "../contacts.objects";
import { SiteEntity } from "../../sites/sites.objects";

export class ContactDialog {
    contact: ContactListingFormObject;
    sites: SiteEntity[];
    prefixes: any[];
    jobFunctions: JobFunctionEntity[];
    studySiteMap: Map<string, string[]> = new Map();

    successCallback: (response: any) => void;

    constructor(allSitesJson: any, allJobFunctions) {
        customElements.define('site-section', SiteSection);
        customElements.define('study-section', StudySection);
        this.sites = plainToClass(SiteEntity, <SiteEntity[]>allSitesJson);
        this.sites.forEach((site: SiteEntity) => { site.initialize(); });
        this.jobFunctions = plainToClass(JobFunctionEntity, <JobFunctionEntity[]>allJobFunctions);
        this.prefixes = [
            { Id: 'Mr.', Name: 'Mr.' },
            { Id: 'Ms.', Name: 'Ms.' },
            { Id: 'Mrs.', Name: 'Mrs.' },
            { Id: 'Dr.', Name: 'Dr.' }
        ];

        this.setUpDialog();
    }

    populateModal(c) {
        this.contact = plainToClass(ContactListingFormObject, <ContactListingFormObject>c);
        this.contact.initialize();

        this.clearContactModal();

        const title = document.getElementById('newContactDialogLabel');
        title.innerHTML = 'Edit Contact';
        const firstNameInput = document.getElementById('firstName') as HTMLInputElement;
        const lastNameInput = document.getElementById('lastName') as HTMLInputElement;
        const emailInput = document.getElementById('email') as HTMLInputElement;
        const phoneInput = document.getElementById('phoneNumber') as HTMLInputElement;
        const prefixInput = document.getElementById('prefix') as HTMLSelectElement;
        const titleInput = document.getElementById('title') as HTMLInputElement;
        const notesInput = document.getElementById('notes') as HTMLInputElement;
        const idInput = document.getElementById('id') as HTMLInputElement;
        firstNameInput.value = this.contact.FirstName;
        lastNameInput.value = this.contact.LastName;
        emailInput.value = this.contact.Email;
        phoneInput.value = this.contact.PhoneNumber;
        const prefix = this.prefixes.find(prefix => prefix.Name == this.contact.Prefix);
        prefixInput.value = prefix ? prefix.Id.toString() : "Select an option";
        titleInput.value = this.contact.Title;
        notesInput.value = this.contact.Notes;
        idInput.value = String(this.contact.Id);


        this.contact.Sites.forEach((site) => {
            const siteSectionId = this.addSiteSection();
            const siteId = site.SiteId;
            const siteSelect = document.getElementById('site-' + siteSectionId) as HTMLSelectElement;
            siteSelect.value = siteId.toString();
            site.StudyIds.forEach((sid, idx) => {
                this.addStudySection(siteSectionId);
            });
            for (let i = 0; i < site.StudyIds.length; i++) {
                const studySectionId = this.studySiteMap.get(siteSectionId)[i];
                const studySelect = document.getElementById('study-' + siteSectionId + '-' + studySectionId) as HTMLSelectElement;
                studySelect.value = site.StudyIds[i].toString();
                const jobFunctionSelect = document.getElementById('jobFunction-' + siteSectionId + '-' + studySectionId) as HTMLSelectElement;
                jobFunctionSelect.value = site.JobFunctionIds[i] != null ? site.JobFunctionIds[i].toString() : '-1';
                const isPrimaryContactInput = document.getElementById('isPrimaryContact-' + siteSectionId + '-' + studySectionId) as HTMLInputElement;
                isPrimaryContactInput.checked = site.IsPrimaryContacts[i];
                const isReceivingAllCommunicationsInput = document.getElementById('isReceivingAllCommunications-' + siteSectionId + '-' + studySectionId) as HTMLInputElement;
                isReceivingAllCommunicationsInput.checked = site.IsReceivingAllCommunications[i];
            }
        });

    }

    populateDropdown(id: string, options: any[]): void {
        const select = document.getElementById(id);
        if (select?.hasChildNodes()) {
            while (select.firstChild) {
                select.removeChild(select.firstChild);
            }
        }
        for (let i = 0; i < options.length; i++) {
            if (i == 0) {
                const defaultOption = document.createElement('option');
                defaultOption.value = '-1';
                defaultOption.text = 'Select an option';
                select?.appendChild(defaultOption);
            }
            const option = document.createElement('option');
            option.value = options[i].Id.toString();
            if (id.includes('site')) option.text = options[i].SiteName;
            else option.text = options[i].Name;
            select?.appendChild(option);
        }
    }

    populateStudy(val: string, siteSectionId: string, targetStudySectionId?: string) {
        if (val == '-1') return;

        const studySections = targetStudySectionId
            ? [targetStudySectionId]
            : this.studySiteMap.get(siteSectionId);
        if (!studySections) return;
        studySections.forEach((studySectionId) => {
            const defaultOption = document.createElement('option');
            defaultOption.value = '-1';
            defaultOption.text = 'Select an option';
            const studyId = 'study-' + siteSectionId + '-' + studySectionId;
            const studySelect = document.getElementById(studyId);
            if (studySelect) {
                studySelect?.removeAttribute('disabled');

                if (studySelect?.hasChildNodes()) {
                    while (studySelect.firstChild) {
                        studySelect.removeChild(studySelect.firstChild);
                    }
                }
                studySelect?.appendChild(defaultOption);

                const siteId = Number(val);
                const site = this.sites.find(s => s.Id == siteId);
                const studies = site.CTMSStudies;
                for (let i = 0; i < studies.length; i++) {
                    const option = document.createElement('option');
                    option.value = studies[i].Id.toString();
                    option.text = studies[i].Name;
                    studySelect?.appendChild(option);
                }
            }
        });
    }

    clearContactModal(): void {
        this.studySiteMap = new Map();
        const title = document.getElementById('newContactDialogLabel');
        title.innerHTML = 'New Contact';
        const validationError = document.getElementById('validation-error');
        validationError.classList.add('d-none');
        const firstNameInput = document.getElementById('firstName') as HTMLInputElement;
        const lastNameInput = document.getElementById('lastName') as HTMLInputElement;
        const emailInput = document.getElementById('email') as HTMLInputElement;
        const phoneInput = document.getElementById('phoneNumber') as HTMLInputElement;
        const prefixInput = document.getElementById('prefix') as HTMLSelectElement;
        const siteContainer = document.getElementById('site-container');
        siteContainer.innerHTML = '';
        const titleInput = document.getElementById('title') as HTMLInputElement;
        const notesInput = document.getElementById('notes') as HTMLInputElement;
        const idInput = document.getElementById('id') as HTMLInputElement;
        firstNameInput.value = '';
        lastNameInput.value = '';
        emailInput.value = '';
        phoneInput.value = '';
        prefixInput.value = '-1';
        titleInput.value = '';
        notesInput.value = '';
        idInput.value = '-1';

        this.populateDropdown('jobFunction', this.jobFunctions);
        this.populateDropdown('site', this.sites);
        this.populateDropdown('prefix', this.prefixes);
    }

    setUpDialog(): void {
        $('#newContactDialog .ctms-button-save').on('click', () => {
            this.saveForm();
        });
        $('#add-site-button').on('click', () => {
            this.addSiteSection();
        });
        $('#newContactDialog').on('hidden.bs.modal', () => {
            this.clearContactModal();
        });
        // experiment with hiding the validation error message once validation issues are fixed
        //$('#firstName, #lastName, #email, #phoneNumber').on('input', () => {
        //    this.updateValidationVisibility();
        //});
        //$('#site-container').on('change', '[id^="site-"], [id^="study-"], [id^="jobFunction-"]', () => {
        //    this.updateValidationVisibility();
        //});
        this.addSiteSection();
    }

    addSiteSection(): string {
        const siteContainer = document.getElementById('site-container');
        const siteSection = document.createElement('site-section') as SiteSection;
        //generate unique random ID so deletion doesn't mess up indexing
        const siteSectionId = crypto.randomUUID();
        siteSection.siteSectionId = siteSectionId;
        siteSection.initialize();
        siteContainer?.appendChild(siteSection);
        this.setupSiteRemoveButton(siteSectionId);
        this.populateDropdown('site-' + siteSectionId, this.sites)
        $('#site-' + siteSectionId).on('change', (e) => {
            const selectedValue = (e.target as HTMLSelectElement).value;
            this.populateStudy(selectedValue, siteSectionId);
        });
        $('#add-study-' + siteSectionId).on('click', () => {
            this.addStudySection(siteSectionId);
        });
        return siteSectionId;
    }

    setupSiteRemoveButton(siteSectionId: string): void {
        $('#remove-button-' + siteSectionId + '-site').on('click', () => {
            this.removeSiteSection(siteSectionId);
        });
    }

    removeSiteSection(siteSectionId: string): void {
        const sectionToRemove = document.getElementById('site-section-' + siteSectionId);
        sectionToRemove?.remove();
        this.studySiteMap.delete(siteSectionId);
    }

    addStudySection(siteSectionId: string): void {
        const studyContainer = document.getElementById('study-container-' + siteSectionId);
        const studySectionId = crypto.randomUUID();
        const studySection = document.createElement('study-section') as StudySection;
        studySection.siteSectionId = siteSectionId;
        studySection.studySectionId = studySectionId;
        studySection.initialize();
        studyContainer?.appendChild(studySection);
        this.setupStudyRemoveButton(siteSectionId, studySectionId);
        this.populateDropdown('jobFunction-' + siteSectionId + '-' + studySectionId, this.jobFunctions);

        if (!this.studySiteMap.has(siteSectionId)) {
            this.studySiteMap.set(siteSectionId, []);
        }
        this.studySiteMap.get(siteSectionId).push(studySectionId);
        this.populateStudy($('#site-' + siteSectionId).val() as string, siteSectionId, studySectionId);
    }

    setupStudyRemoveButton(siteSectionId: string, studySectionId: string): void {
        $('#study-remove-button-' + siteSectionId + '-' + studySectionId).on('click', () => {
            this.removeStudySection(siteSectionId, studySectionId);
        });
    }

    removeStudySection(siteSectionId: string, studySectionId: string): void {
        const sectionToRemove = document.getElementById('study-section-' + siteSectionId + '-' + studySectionId);
        sectionToRemove?.remove();
        const studyIds = this.studySiteMap.get(siteSectionId);
        if (studyIds) {
            const idx = studyIds.indexOf(studySectionId);
            if (idx !== -1) {
                studyIds.splice(idx, 1);
            }
        }
    }

    updateValidationVisibility(): void {
        const validationError = document.getElementById('validation-error');
        if (validationError && !validationError.classList.contains('d-none')) {
            if (this.validateForm()) {
                validationError.classList.add('d-none');
            }
        }
    }

    saveForm(): void {
        const validationError = document.getElementById('validation-error');
        if (this.validateForm()) {
            validationError.classList.add('d-none');
            $.ajax({
                url: '/secure/ctms/contacts/contacts?handler=Save',
                type: 'POST',
                data: $('#newContactDialog .ctms-field-submit').serialize(),
                headers: {
                    'RequestVerificationToken': $('input[name="__RequestVerificationToken"]').val() as string
                },
                success: (response) => {
                    this.successCallback(response);
                },
            });
            $(`#newContactDialog`).modal('hide');
        }
        else {
            validationError.classList.remove('d-none');
        }
    }

    validateForm(): boolean {
        const firstNameInput = document.getElementById('firstName') as HTMLInputElement;
        const lastNameInput = document.getElementById('lastName') as HTMLInputElement;
        const emailInput = document.getElementById('email') as HTMLInputElement;
        const phoneInput = document.getElementById('phoneNumber') as HTMLInputElement;
        if (firstNameInput.value == '' || lastNameInput.value == '' || emailInput.value == '' || phoneInput.value == '') return false;
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!regex.test(emailInput.value.trim())) return false

        // at least one site section must exist with a site selected
        const siteSelects = document.querySelectorAll(`select[name$="].SiteId"]`);
        if (siteSelects.length == 0) return false;
        for (let i = 0; i < siteSelects.length; i++) {
            const siteSelect = siteSelects[i] as HTMLSelectElement;
            if (siteSelect.value == "-1") return false;
        }
        // if study sections exist, Study and Role must be selected
        const studySelects = document.querySelectorAll(`[id^="study-"]`) as NodeListOf<HTMLSelectElement>;
        for (let i = 0; i < studySelects.length; i++) {
            if (studySelects[i].value == "-1") return false;
        }
        const jobFunctionSelects = document.querySelectorAll(`[id^="jobFunction-"]`) as NodeListOf<HTMLSelectElement>;
        for (let i = 0; i < jobFunctionSelects.length; i++) {
            if (jobFunctionSelects[i].value == "-1") return false;
        }
        return true;
    }

    populateReadonlyModal(c: any): void {
        this.contact = plainToClass(ContactListingFormObject, <ContactListingFormObject>c);
        this.contact.initialize();

        // Set readonly fields
        const setText = (id: string, value: string | number | null | undefined) => {
            const el = document.getElementById(id);
            if (el) el.textContent = String(value ?? '');
        };
        setText('firstNameReadonly', this.contact.FirstName);
        setText('lastNameReadonly', this.contact.LastName);
        setText('prefixReadonly', this.contact.Prefix);
        setText('emailReadonly', this.contact.Email);
        setText('phoneNumberReadonly', this.contact.PhoneNumber);
        setText('titleReadonly', this.contact.Title);
        setText('notesReadonly', this.contact.Notes);
        setText('idReadonly', this.contact.Id);

        // Render sites/studies/roles in readonly format
        const siteContainer = document.getElementById('site-container-readonly');
        if (siteContainer) {
            siteContainer.innerHTML = '';
            if (Array.isArray(this.contact.Sites) && this.contact.Sites.length > 0) {
                this.contact.Sites.forEach((site, siteIdx) => {
                    // Lookup site entity
                    const siteEntity = this.sites.find(s => s.Id === site.SiteId);
                    const siteName = siteEntity ? siteEntity.SiteName : '';
                    const studies = siteEntity ? siteEntity.CTMSStudies : [];

                    // Site header
                    const siteDiv = document.createElement('div');
                    siteDiv.className = 'ctms-section-content-wrapper mb-2';
                    siteDiv.innerHTML = `
                        <div class="row">
                            <div class="col-6">
                                <div class="form-group ctms-form-group">
                                    <label>Site</label>
                                    <div class="ctms-form-text">${siteName}</div>
                                </div>
                            </div>
                        </div>
                    `;
                    // Studies/roles for this site
                    if (Array.isArray(site.StudyIds) && site.StudyIds.length > 0) {
                        for (let i = 0; i < site.StudyIds.length; i++) {
                            // Lookup study name
                            const studyId = site.StudyIds[i];
                            const studyObj = studies ? studies.find(study => study.Id === studyId) : null;
                            const studyName = studyObj ? studyObj.Name : '';
                            // Lookup job function name
                            const jobFunctionId = site.JobFunctionIds[i];
                            const jobFunctionObj = this.jobFunctions.find(jf => jf.Id === jobFunctionId);
                            const jobFunctionName = jobFunctionObj ? jobFunctionObj.Name : '';
                            // Primary/Receive All
                            const isPrimary = site.IsPrimaryContacts && site.IsPrimaryContacts[i] ? 'Yes' : 'No';
                            const isReceivingAll = site.IsReceivingAllCommunications && site.IsReceivingAllCommunications[i] ? 'Yes' : 'No';

                            const studyDiv = document.createElement('div');
                            studyDiv.className = 'row ml-3';
                            studyDiv.innerHTML = `
                                <div class="col-3">
                                    <div class="form-group ctms-form-group">
                                        <label>Study</label>
                                        <div class="ctms-form-text">${studyName}</div>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="form-group ctms-form-group">
                                        <label>Role</label>
                                        <div class="ctms-form-text">${jobFunctionName}</div>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="form-check ctms-form-group">
                                        <label>Primary Contact</label>
                                        <div class="ctms-form-text">${isPrimary}</div>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="form-check ctms-form-group">
                                        <label>Receive All Communications</label>
                                        <div class="ctms-form-text">${isReceivingAll}</div>
                                    </div>
                                </div>
                            `;
                            siteDiv.appendChild(studyDiv);
                        }
                    }
                    siteContainer.appendChild(siteDiv);
                });
            } else {
                // No sites
                siteContainer.innerHTML = '<div class="text-muted">No site assignments.</div>';
            }
        }
    }

}

export class SiteSection extends HTMLElement {
    siteSectionId: string;


    initialize(): void {

    }

    connectedCallback(): void {
        this.innerHTML =
            `<div class="ctms-section-content-wrapper" id="site-section-${this.siteSectionId}">
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group ctms-form-group">
                                <label for="site">Site</label>
                                <select class="form-control ctms-field-submit" name="SiteStudyContainers[${this.siteSectionId}].SiteId" id="site-${this.siteSectionId}"></select>
                            </div>
                        </div>
                        <button type="button" class="ctms-remove-button ctms-button" id="remove-button-${this.siteSectionId}-site"><i class="fa-solid fa-xmark"></i></button>
                    </div>
                    <div id="study-container-${this.siteSectionId}">

                    </div>
                    <div class="row ml-3">
                        <div class="col-4">
                            <button type="button" class="ctms-button ctms-dialog-button" id="add-study-${this.siteSectionId}">+ Add Study</button>
                        </div>
                    </div>
                </div>`
    }
}

export class StudySection extends HTMLElement {
    studySectionId: string;
    siteSectionId: string;


    initialize(): void {

    }

    connectedCallback(): void {
        this.innerHTML =
            `<div class="ctms-section-content-wrapper" id="study-section-${this.siteSectionId}-${this.studySectionId}">
                <div class="row ml-3" id="study-section-${this.siteSectionId}-${this.studySectionId}">
                <div class="col-4">
                    <div class="form-group ctms-form-group">
                        <label for="study-${this.siteSectionId}-${this.studySectionId}">Study</label>
                        <select class="form-control ctms-field-submit" name="SiteStudyContainers[${this.siteSectionId}].StudyId[${this.studySectionId}]" id="study-${this.siteSectionId}-${this.studySectionId}"></select>
                    </div>
                </div>
                <div class="col-4">
                    <div class="form-group ctms-form-group">
                        <label for="jobFunction-${this.siteSectionId}-${this.studySectionId}">Role</label>
                        <select class="form-control ctms-field-submit" name="SiteStudyContainers[${this.siteSectionId}].JobFunctionId[${this.studySectionId}]" id="jobFunction-${this.siteSectionId}-${this.studySectionId}"></select>
                    </div>
                </div>
                <div class="col-2">
                    <div class="form-check ctms-form-check">
                        <input class="form-check-input ctms-field-submit" type="checkbox" value="true" name="SiteStudyContainers[${this.siteSectionId}].IsPrimaryContact[${this.studySectionId}]" id="isPrimaryContact-${this.siteSectionId}-${this.studySectionId}">
                        <input type="hidden" class="ctms-field-submit" name="SiteStudyContainers[${this.siteSectionId}].IsPrimaryContact[${this.studySectionId}]" value="false" />
                        <label class="form-check-label" for="isPrimaryContact-${this.siteSectionId}-${this.studySectionId}">Primary Contact</label>
                    </div>
                    <div class="form-check ctms-form-check">
                        <input class="form-check-input ctms-field-submit" type="checkbox" value="true" name="SiteStudyContainers[${this.siteSectionId}].IsReceivingAllCommunications[${this.studySectionId}]" id="isReceivingAllCommunications-${this.siteSectionId}-${this.studySectionId}">
                        <input type="hidden" class="ctms-field-submit" name="SiteStudyContainers[${this.siteSectionId}].IsReceivingAllCommunications[${this.studySectionId}]" value="false" />
                        <label class="form-check-label" for="isReceivingAllCommunications-${this.siteSectionId}-${this.studySectionId}">Receive All Communications</label>
                    </div>
                </div>
                <button type="button" class="ctms-remove-button ctms-button" id="study-remove-button-${this.siteSectionId}-${this.studySectionId}"><i class="fa-solid fa-xmark"></i></button>
            </div></div>`
    }
}